/**
 * ⚖️ WHICH VERSION OF WHAT DID THEY AGREE TO.
 *
 * GC-018: sign-up showed the sentence "By creating an account you agree to
 * our Terms and Privacy Policy" and stored nothing at all. So the answer to
 * "which terms is this member on?" — the only question that matters when the
 * terms change, when somebody disputes a charge, or when a regulator asks —
 * was "we don't know, for anybody".
 *
 * The People master schema has had the home for this since it was written
 * (P31 `agreements[]`: kind, version, acceptedAt, surface) and recorded its
 * own status as "terms not stored". This is the missing half: the version
 * the product is currently serving.
 *
 * ── Rules ───────────────────────────────────────────────────────────
 *
 *   • Dated, not numbered. "2026-09-01" says when the text a person agreed
 *     to was published; "v3" says nothing anybody can check.
 *   • The SERVER stamps it. A version that arrives in a request body is a
 *     claim by the browser, and a record of consent that the consenting
 *     party can edit is not a record. The dashboard reads these to print
 *     the date next to the checkbox; the gateway ignores what it is sent.
 *   • Bump the date here when the published text changes, in the same
 *     commit. A changed document with an unchanged version is worse than
 *     no version, because it looks like an answer.
 *
 * The cookie banner carries its own CONSENT_VERSION (three hand-typed copies
 * of '2026-03-17' across the dashboard). That is a different agreement with
 * a different lifecycle, and folding it in here would need the three call
 * sites migrating together — noted, not done.
 */

/** The published Terms of Service a new account is agreeing to. */
export const TERMS_VERSION = '2026-09-01';

/** The published Privacy Policy referenced by the same sentence. */
export const PRIVACY_VERSION = '2026-09-01';

/**
 * Moksy is an 18+ platform: reviewers are paid, members hold a wallet, and
 * both are contracts a minor cannot enter. Stated once so the checkbox, the
 * profile screen and any later gate all say the same number.
 */
export const MINIMUM_AGE = 18;

/** The kinds P31 `agreements[]` accepts, so a caller cannot invent one. */
export const AGREEMENT_KINDS = Object.freeze([
  'terms', 'privacy', 'reviewer_agreement', 'code_of_conduct',
  'card_mandate', 'ownership_declaration'
]);

export default { TERMS_VERSION, PRIVACY_VERSION, MINIMUM_AGE, AGREEMENT_KINDS };
